var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eventValue)?_c('a',{class:_vm.buttonClasses,style:(_vm.buttonStyles),on:{"click":_vm.emitClick}},[_vm._t("default",function(){return [_vm._v("\n    NO LABEL\n  ")]})],2):_c('a',{class:_vm.buttonClasses,style:(_vm.buttonStyles),attrs:{"href":_vm.url}},[_vm._t("default",function(){return [_vm._v("\n    NO LABEL\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }